export enum LenderToRefinance {
    Tbd = 0,
    Bfi = 1,
    NonBank = 2,
    Bank = 3,
}
